export const appZIndex = {
  modal: 10000000000000000,
  tooltips: 10000000000000001,
};
